import i18next from '@v4/utils/i18n'

export const createGetWording = translate => (key, options) => {
	return _.get(window?.SCOREAPP_WORDINGS, key) || translate(key, options) || ''
}

export const getWording = (key, options) => createGetWording(i18next.t)(key, options)
